import createTypeDecorator from '../decorators/createTypeDecorator'

export const ANY = Symbol("schemer.types.ANY")

export const any = createTypeDecorator(ANY, {
  formatDisplay: val => val, // Direct passthrough, consumers are expected to override this
  table: {
    width: 400
  }
})
